import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble6: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-6, message, chat"><path d="M2.75 8.75C2.75 5.98858 4.98858 3.75 7.75 3.75H16.25C19.0114 3.75 21.25 5.98858 21.25 8.75V15.25C21.25 18.0114 19.0114 20.25 16.25 20.25H2.75V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBubble6;
